/*
 *
 * ShopSelector
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 01-Apr-2025
*/

import ShopSelector from './ShopSelectorContainer'

export default ShopSelector
